import React from 'react';

import Grid, { GridItem } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';
import Spacing from '@marvelapp/marvel-ui/spacing';

import HeadingBlock from 'marketing-website/components/modules/HeadingBlock';
import CollaborationArtwork from 'marketing-website/components/modules/CollaborationArtwork';

export default function Web() {
  return (
    <PageWrap size="l">
      <Grid columns={12} alignItems="center">
        <GridItem columnSpan={12} columnSpanM={6}>
          <Spacing size="l" sizeM="0" type="margin" position="topBottom">
            <HeadingBlock
              size="s"
              spacing="m"
              justifyM="center"
              title="Go to the next level with our web app."
              copy="Invite clients and co-workers to projects and get access to a ton of extra features."
            />
          </Spacing>
        </GridItem>
        <GridItem columnSpan={12} columnSpanM={6}>
          <CollaborationArtwork
            color="brightOrange"
            patternColor="orangeLight"
          />
        </GridItem>
      </Grid>
    </PageWrap>
  );
}



// WEBPACK FOOTER //
// ./src/pages/pop/Web.js